/**
 * Generates a consistent methodology description for salary data
 * @param companyName The name of the company
 * @param sampleSize The number of job descriptions analyzed
 * @param options.withHyperlinks Whether to include hyperlinks in the text
 * @param options.permalink Company permalink for job links
 */
export function generateSalaryMethodologyText(
  companyName: string,
  sampleSize?: number,
  options?: {
    withHyperlinks?: boolean
    permalink?: string
  }
): string {
  const sampleSizeText = sampleSize ? sampleSize.toLocaleString() : ''
  const baseText = `Salary data for ${companyName} is based on a combination of sources, including analysis of ${sampleSizeText} verified job descriptions and statistics from the U.S. Bureau of Labor Statistics (BLS).`

  // Return plain text if hyperlinks are not requested or if permalink is missing
  if (!options?.withHyperlinks || !options?.permalink) {
    return baseText
  }

  // Add hyperlinks for job descriptions and BLS
  return baseText
    .replace(
      `${sampleSizeText} verified job descriptions`,
      `<a href="/company/${options.permalink}/jobs" class="text-primary-600 hover:text-primary-800">${sampleSizeText} verified job descriptions</a>`
    )
    .replace(
      'U.S. Bureau of Labor Statistics (BLS)',
      '<a href="https://www.bls.gov/" target="_blank" rel="noopener noreferrer" class="text-primary-600 hover:text-primary-800">U.S. Bureau of Labor Statistics (BLS)</a>'
    )
}
